import cleanedFilename from '~/util/cleanedFilename';

export default {
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
  SUBMIT_BUTTON: `${cleanedFilename(__filename)}-submit-button`,
};
